import { FormErrors } from '@shared/modules/form/types'
import { ManufacturerCountryApi, ManufacturerCountry } from '../../manufacturer-countries/types'
import { MeasurementApiSubset } from '../../measurements/types'
import { StatusApiSubset } from '../../status/types'
import { ProductCategoryApiSubset } from './categories'

export enum ProductType {
  INVENTORY = 'inventory',
  PRODUCT = 'product',
}

export type ProductSelectApi = {
  id: number
  product_name: string
  item_code: string
  barcode: string
  has_expiry_date: boolean
  measurement_unit_name: string
  category_name: string
  descr: string
}

export type ProductSelect = {
  id: number
  name: string
  itemCode: string
  barcode: string
  hasExpiryDate: boolean
  measurementUnitName: string
  categoryName: string
  descr: string
}

export type Product = {
  id: number
  name: string
  descr: string
  barcode: string
  price: number
  itemCode: string
  country: ManufacturerCountry
  type: ProductType
  criticalThreshold: number
  hasExpireDate: boolean
  category: { id: number; name: string }
  status: { id: number; name: string }
  measurementUnit: { id: number; name: string; symbol: string }
  createdAt: string
  updatedAt: string
}

export type ProductApi = {
  id: number
  product_name: string
  descr: string
  barcode: string
  price: number
  type: ProductType
  item_code: string
  manufacturer_country: ManufacturerCountryApi | null
  critical_threshold: number
  has_expiry_date: boolean
  product_category_id: number
  category: ProductCategoryApiSubset
  state_id: number
  state: StatusApiSubset
  measurement_unit_id: number
  measurement_unit: MeasurementApiSubset
  created_at: string
  updated_at: string
}

export type ProductFormData = {
  id?: string
  productName: string
  type: ProductType
  itemCode: string
  barcode: string
  measurementUnitId: number | string
  criticalThreshold: number
  hasExpiryDate: boolean
  categoryId: string
  statusId: string
  manufacturerCountryId: number | string
  descr: string
}

export type ProductFormDataApi = {
  product_id?: string
  product_name: string
  type: ProductType
  barcode: string
  item_code: string
  measurement_unit_id: number | string
  critical_threshold: number
  has_expiry_date: 0 | 1
  product_category_id: string
  state_id: string
  manufacturer_country_id: number | string
  descr: string
}

export type ProductApiSubset = Pick<ProductApi, 'id' | 'product_name' | 'barcode' | 'item_code' | 'measurement_unit' | 'has_expiry_date'>

export type ProductFormErrors = FormErrors<ProductFormData>
export type ProductFormErrorsApi = FormErrors<ProductFormDataApi>
